import React from "react";

function NotAuthenticated({ redirectUrl }) {
    return (

        <div className="right-pane" style={{width: '100%', paddingLeft: 132, paddingTop: 150, position: 'absolute', left: 330}}>

            Please log in <a href={redirectUrl}>here</a> to view this page.
        </div>);
}

export default NotAuthenticated;